import { atom, useAtom } from 'jotai';
import { nanoid } from 'nanoid';

function formatDate(date) {
  const h = '0' + date.getHours();
  const m = '0' + date.getMinutes();
  console.log('creating date', `${h.slice(-2)}:${m.slice(-2)}`);

  return `${h.slice(-2)}:${m.slice(-2)}`;
}

export const messageHistoryAtomEn = atom([
  // {
  //   intent: 'PromtData',
  //   chat: [
  //     {
  //       id: nanoid(),
  //       Role: 'assistant',
  //       Type: 0,
  //       Message: 'Hi, welcome I am Millada! Go ahead and ask me something about your data. 😄',
  //       sent: formatDate(new Date()),
  //     },
  //   ],
  // },
  {
    intent: 'PromtEmbeddings',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Here, I can help you with your documents.',
        sent: formatDate(new Date()),
      },
    ],
  },
  {
    intent: 'PromptGpt',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Hi, how can I help you?',
        sent: formatDate(new Date()),
      },
    ],
  },
]);

export const messageHistoryAtom = atom([
  // {
  //   intent: 'PromtData',
  //   chat: [
  //     {
  //       id: nanoid(),
  //       Role: 'assistant',
  //       Type: 0,
  //       Message: 'Hi, welcome I am Millada! Go ahead and ask me something about your data. 😄',
  //       sent: formatDate(new Date()),
  //     },
  //   ],
  // },
  {
    intent: 'PromtEmbeddings',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Here, I can help you with your documents.',
        sent: formatDate(new Date()),
      },
    ],
  },
  {
    intent: 'PromptGpt',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Hi, how can I help you?',
        sent: formatDate(new Date()),
      },
    ],
  },
]);

export const messageHistoryAtomSk = atom([
  // {
  //   intent: 'PromtData',
  //   chat: [
  //     {
  //       id: nanoid(),
  //       Role: 'assistant',
  //       Type: 0,
  //       Message: 'Ahoj, vitajte, ja som Millada! Opýtajte sa ma na niečo o vašich dátach. 😄',
  //       sent: formatDate(new Date()),
  //     },
  //   ],
  // },
  {
    intent: 'PromtEmbeddings',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Ahoj, ako Ti môžem pomôcť s dokumentami?',
        sent: formatDate(new Date()),
      },
    ],
  },
  {
    intent: 'PromptGpt',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Ahoj, ako Ti môžem pomôcť?',
        sent: formatDate(new Date()),
      },
    ],
  },
]);

export const messageHistoryAtomCz = atom([
  // {
  //   intent: 'PromtData',
  //   chat: [
  //     {
  //       id: nanoid(),
  //       Role: 'assistant',
  //       Type: 0,
  //       Message: 'Ahoj, vítejte, já jsem Millada! Zeptejte se mě na cokoli ohledně vašich dat. 😄',
  //       sent: formatDate(new Date()),
  //     },
  //   ],
  // },
  {
    intent: 'PromtEmbeddings',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Ahoj, jak vám mohu pomoci s dokumenty?',
        sent: formatDate(new Date()),
      },
    ],
  },
  {
    intent: 'PromptGpt',
    chat: [
      {
        id: nanoid(),
        Role: 'assistant',
        Type: 0,
        Message: 'Ahoj, jak Ti můžu pomoci?',
        sent: formatDate(new Date()),
      },
    ],
  },
]);

export function useMessageHistoryAtom(lang) {
  var myLang;
  if (lang === 'en') {
    myLang = messageHistoryAtomEn;
  } else if (lang === 'sk') {
    myLang = messageHistoryAtomSk;
  } else if (lang === 'cz') {
    myLang = messageHistoryAtomCz;
  }
  return useAtom(myLang);
}
